import React, { useEffect, useState } from 'react';
import dataProvider from '../../../providers/dataProvider';
import { Box, Card, Button } from '@material-ui/core';

import AddIcon from '@material-ui/icons/AddCircleOutline';
import SingleOrderDiscountRow from './SingleOrderDiscountRow';

import './styles.css';
import { SingleOrderDiscount, DiscountValueType } from './types';

type BoostError = Partial<Record<keyof SingleOrderDiscount, string>>;

const DEFAULT_BOOST: SingleOrderDiscount = {
  isActive: true,
  title: '',
  source: 'ALL',
  label: '',
  totalCost: 0,
  discountValue: 0,
  discountValueType: 'FIXED_AMOUNT',
  numOfTickets: 0,
};

const SingleOrderDiscountTab = () => {
  const [discounts, setDiscounts] = useState<SingleOrderDiscount[]>([]);
  const [errors, setErrors] = useState<BoostError[]>([]);
  const [generalId, setGeneralId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    console.log('discounts: ', discounts);
  }, [discounts]);

  const init = async () => {
    const res = await dataProvider.getGeneral();
    const data = res.data;

    if (data?.singleOrdersDiscount) {
      setDiscounts(data.singleOrdersDiscount);
      setGeneralId(data._id);
    }
  };

  const NUMBER_FIELDS: (keyof SingleOrderDiscount)[] = [
    'totalCost',
    'discountValue',
    'numOfTickets',
  ];

  const updateBoost = React.useCallback(
    <K extends keyof SingleOrderDiscount>(
      index: number,
      field: K,
      value: SingleOrderDiscount[K],
    ) => {
      let parsedValue = value;

      if (NUMBER_FIELDS.includes(field)) {
        parsedValue = (
          value === '' ? 0 : Number(value)
        ) as SingleOrderDiscount[K];
      }

      setDiscounts((prev) => {
        const copy = [...prev];
        copy[index] = { ...copy[index], [field]: parsedValue };
        return copy;
      });
    },
    [],
  );

  const addBoost = () => {
    setDiscounts((prev) => [...prev, { ...DEFAULT_BOOST }]);
  };

  const removeBoost = (index: number) => {
    setDiscounts((prev) => prev.filter((_, i) => i !== index));
  };

  const validate = () => {
    const newErrors: BoostError[] = discounts.map((b, i) => {
      const err: BoostError = {};

      // if (!b.title) err.title = 'Required';
      if (!b.discountValue) err.discountValue = 'Required';
      if (b.totalCost <= 0) err.totalCost = 'Must be > 0';

      // const duplicate = discounts.find(
      //   // (x, idx) => x.orderCost === b.orderCost && idx !== i,
      //   (x, idx) =>
      //     x.orderCost === b.orderCost &&
      //     b.orderType === x.orderType &&
      //     idx !== i,
      // );

      // if (duplicate) err.orderCost = 'Must be unique';

      return err;
    });

    setErrors(newErrors);
    return newErrors.every((e) => Object.keys(e).length === 0);
  };

  const save = async () => {
    if (!generalId || !validate()) return;

    setIsLoading(true);
    try {
      await dataProvider.updateGeneral({
        id: generalId,
        data: { singleOrdersDiscount: discounts },
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleChange = updateBoost;
  return (
    <Card className='tabCardWrapper orders-boost'>
      <h3>Single Orders Discounts</h3>

      {discounts.map((discountItem, i) => (
        <SingleOrderDiscountRow
          key={i}
          discountItem={discountItem}
          index={i}
          errors={errors[i]}
          onChange={handleChange}
          onRemove={removeBoost}
        />
      ))}

      {/* ADD */}
      <Box mt={2}>
        <Button startIcon={<AddIcon />} onClick={addBoost}>
          Add discount
        </Button>
      </Box>

      {/* SAVE */}
      <Box mt={2}>
        <Button
          variant='contained'
          color='primary'
          onClick={save}
          disabled={isLoading}
        >
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </Box>
    </Card>
  );
};

export default SingleOrderDiscountTab;
